import {useEffect} from 'react'
import * as PurpleDot from '@purple-dot/browser'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const PurpleDotInit = () => {
    const {
        app: {commerceAPI}
    } = getConfig()

    const {config} = commerceAPI.purpleDot || {}
    var enablePurpleDot = false
    var apiKey = null

    try {
        if (config) {
            const jsonConfig = JSON.parse(config)
            enablePurpleDot = jsonConfig.enabled
            apiKey = jsonConfig.apiKey
        }
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        if (enablePurpleDot) {
            PurpleDot.init({
                apiKey: apiKey
            })
        }
    }, [])
}
export default PurpleDotInit
